import axios from "../../utils/axios";
import type { PeopleDTO } from "../types/riskAssessmentDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchAllPeople = () => axios.get<PeopleDTO[]>(`${apiUrl}/People/GetAll`);

const peopleService = {
    fetchAllPeople,
};

export default peopleService;
